module.exports = __webpack_public_path__ + "static/img/bgImg.43e6546.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slider-verify-dt/src/assets/images/bgImg.jpg
// module id = JeHs
// module chunks = 1